import { render, staticRenderFns } from "./MegaPromoArt.vue?vue&type=template&id=650f261a"
import script from "./MegaPromoArt.vue?vue&type=script&lang=js"
export * from "./MegaPromoArt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports